<!-- IIT2-1435-start -->
<div *ngIf='!isReviewOpen' class="fade show partner_content" id="reviewPartnerContentTab">
  <div class="d-flex flex-column h-100" id="reviewPartnerConFlex">
    <!-- Data heading and info -->
    <div class="data_header" id="reviewPCDataHeader">
      <div class="results_info mb-3" id="reviewResultsInfo">
        <div class="title" id="reviewTitle">
        <span i18n="@@review-partner-content.header.review-content">Review Content</span></div>
        <ng-container *ngTemplateOutlet='isPartnerTabActive? topShowtoFromPartner : showToFromAttr'></ng-container>
      </div>
      <div ngbDropdown class="dropdown" container="body" *ngIf="partner?.length" id="reviewPCDropDown">
        <button class="btn btn-primary dropdown-toggle" id='approveDropdown' type="button" ngbDropdownToggle>
          {{selectedButton}}
        </button>
        <div ngbDropdownMenu aria-labelledby="approveDropdown" class="dropdown-menu" id="pcDropDownMenu">
          <ng-container *ngFor="let data of partner,let i = index">
            <ng-container *ngIf="partnerLabel !== data">
              <button (click)='selectedPartner(data, partnerID[i])' class="dropdown-item">{{data}}</button>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="mt-3 mb-3 d-flex" id="reviewPartnerConDFlex">
      <ng-container *ngIf='pID'>
        <div class='tab' (click)='tabChange()'
          [ngClass]="{'active-tab':isPartnerTabActive ,'inactive-tab':!isPartnerTabActive}"><span i18n ="@@approved-partner-content.tab-switch.partner-content" id="partnerContent">Partner Content</span>
        </div>
        <div class='tab' (click)='tabChange()'
          [ngClass]="{'active-tab':!isPartnerTabActive ,'inactive-tab':isPartnerTabActive}"><span i18n = "@@approved-partner-content.tab-switch.attract-loop" id="attractLoopVideos">Attract Loop</span>
          videos</div>
      </ng-container>
      <div class="tab-container" id="tabContainer"></div>
    </div>
    <div class="text-center" *ngIf="!spinnerStatus" id="noPartnerConPending"
      [ngClass]="isPartnerEmpty ? 'existing_text_show': 'existing_text_hide'">
      <span i18n="@@review-partner-content.no-partners.there-is-no-partner-content-pending-for-review">There is no
        Partner Content pending for review.</span>
    </div>
    <div class="text-center" *ngIf="!spinnerStatus" id="selectedBtn"
      [ngClass]="selectedButton === 'Select Partner' && !isPartnerEmpty ? 'existing_text_show': 'existing_text_hide'">
      <span
        i18n="@@review-partner-content.select-message-content.please-select-a-parter-to-view-the-review-content">Please
        select a Partner to review the content they submitted.</span>
    </div>
    <ng-container *ngTemplateOutlet='isPartnerTabActive? noDataForPartner : noDataForAttr'></ng-container>

    <!-- Table data -->
    <iposcen-spinner-overlay (getStatus)="spinnerStatus = $event"></iposcen-spinner-overlay>
    <!-- partner table  -->
    <div *ngIf='selectedButton !== "Select Partner"' id="seletedBtnPartner">
      <div *ngIf='isPartnerTabActive; else tableElse' class="table-responsive" id="isPartnerTabActive">
        <div *ngIf = "contents?.length" id="contentsLength">
        <table id="reviewPartnersTable" class="table table-borderless" [ngClass]="{'remove-margin':isNoneSelected}"
          aria-describedby="reviewPartners">
          <thead>
            <tr>
              <th scope="col">
                <span class="table_headings">
                  <span i18n="@@review-partner-content.content-name.content-name">Content Name</span>
                  <span class="chevron_expand" (click)="sort('contentName')"></span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings">
                  <span i18n="@@review-partner-content.language-category.language-category">Language Category</span>
                  <span class="chevron_expand" (click)="sort('languageCategory')"></span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings">
                  <span i18n="@@review-partner-content.system-id.system-id">System ID</span>
                  <span class="chevron_expand" (click)="sort('systemID')"></span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings">
                  <span i18n="@@review-partner-content.created-by.created-by">Created By</span>
                  <span class="chevron_expand" (click)="sort('editedByName')"></span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings">
                  <span i18n="@@review-partner-content.last-updated.last-updated">Last Updated</span>
                  <span class="chevron_expand" (click)="sort('updatedTime')"></span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let data of contents, let i = index">
              <tr>
                <td>{{data.contentName}}</td>
                <td>{{data.languageCategory}}</td>
                <td>{{data.systemID}}</td>
                <td>{{data.editedByName}}</td>
                <td>{{data.updatedTime | dateFormat:'changeToLocalTimeZone'}}</td>
                <td class="review_cell">
                  <span class="modify_record">
                    <button (click)='openView(data,data.contentID, data.autoID)'
                      class="btn btn-link btn-teritiary left_icon_btn">
                      <img class="review-image" alt="view" />
                      <span i18n="@@review-partner-content.review.review">Review</span>
                    </button>
                  </span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        </div>
      </div>
      <!-- Attract loop table  -->
      <ng-template #tableElse>
        <div class="table-responsive" *ngIf='displayAttr?.length' id="dsplyAttractLoop">
          <table id='attractLoop' class="table table-borderless" [ngClass]="{'remove-margin':isNoneSelected}"
            aria-describedby="reviewPartners">
            <thead>
              <th scope="col">
                <span class="table_headings">
                  <span i18n="@@global.search.name">Name</span>
                  <span class="chevron_expand" (click)='sort(oemConst.ATTRACTLOOP_NAME)'></span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings">
                  <span i18n="@@global.search.location">Location</span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings">
                  <span i18n="@@partners.last-updated.last-updated">Last Updated</span>
                  <span class="chevron_expand" (click)='sort(oemConst.UPDATE_TIME)'></span>
                </span>
              </th>
              <th scope="col">
                <span class="table_headings">
                  <span i18n="@@create-partner-content.tableheader.lastupdatedby">Last Updated By</span>
                  <span class="chevron_expand" (click)='sort(oemConst.UPDATE_BY_NAME)'></span>
                </span>
              </th>
            </thead>
            <tbody>
              <ng-container *ngFor="let data of displayAttr | slice: (pageAttr-1) * tableSize : (pageAttr-1) * tableSize + tableSize; index as i">
                <tr>
                  <td>{{data.attractLoopName}}</td>
                  <td>
                    <span *ngIf="data?.parsedLocations?.length == 1">
                      {{data.parsedLocations[0] | translateLocation}}
                    </span>
                    <span *ngIf="data?.parsedLocations?.length > 1 && data?.parsedLocations?.length < 66">
                      {{data.parsedLocations[0] | translateLocation}} 
                      <span class="popup-badge" [ngbPopover]='locationPopUp'
                        [popoverTitle]="data.parsedLocations.length + ' Locations'" placement="right">
                        +{{data.parsedLocations.length - 1}}
                      </span>
                    </span>
                    <span *ngIf="data?.parsedLocations?.length >= 66">
                      All Locations
                    </span>
                  </td>
                  <td>{{data.updatedTime | dateFormat:'changeToLocalTimeZone'}}</td>
                   <!-- Location Popup Template -->
                   <ng-template #locationPopUp>
                    <div id="locationPopupList">
                      <div id="locationMap"
                        [ngClass]="{'popup-size-scroll': data.parsedLocations.length > 5, 'popup-size': data.parsedLocations.length <= 5}">
                        <ul class='reduceLeftPad'>
                          <li class="child" *ngFor='let location of data.parsedLocations'>{{location | translateLocation}}</li>
                        </ul>
                      </div>
                    </div>
                  </ng-template> 
                  <td>{{data.updatedByName}}</td>
                  <td class="review_cell">
                    <span class="modify_record">
                      <button (click)='openView(data.attractLoopId)'
                        class="btn btn-link btn-teritiary left_icon_btn">
                        <img class="review-image" alt="view" />
                        <span i18n="@@review-partner-content.review.review">Review</span>
                      </button>
                    </span>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ng-template>
    </div>

    <hr *ngIf='selectedButton !== "Select Partner" && partner?.length>0'
      [ngClass]="{'remove-margin-top':isNoneSelected}" />

    <!-- Pagination -->
    <div class="data_footer position-relative" *ngIf="(isPartnerTabActive && contents?.length > 0) || (!isPartnerTabActive && displayAttr?.length > 0)" id="dataFooter">
      <div class="d-flex flex-column align-items-center" id="alignPagination">
        <div id="reviewContentsLength">
        <nav aria-label="content pagination">
          <ngb-pagination *ngIf='isPartnerTabActive' [collectionSize]="paginationCount"
            [(page)]="page" [pageSize]="tableSize" [rotate]="false" [maxSize]="maxSize" [ellipses]="true"
            [boundaryLinks]="false" (pageChange)="onTableDataChange($event)">
          </ngb-pagination>
          <ngb-pagination *ngIf="!isPartnerTabActive && displayAttr?.length > 0" [collectionSize]="AttrPageCount" [(page)]="pageAttr" [pageSize]="tableSize" [rotate]="false"
              [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false" (pageChange)="onTableDataChange($event)">
            </ngb-pagination>
        </nav>
        </div>
        <ng-container *ngTemplateOutlet='!isPartnerTabActive && displayAttr?.length ?showToFromAttr:empty'></ng-container>
        <div *ngIf='isPartnerTabActive && contents?.length > 0' class="results mt-2" id="shwoFrm">
          <span i18n="@@review-partner-content.results.showing-of-partner-content-groups">Showing <strong>{{ showFrom }}
              - {{ showTo }} </strong> of <strong> {{ paginationCount }} Partner Content
              Groups</strong></span>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- templates  -->
<ng-template #empty></ng-template>
<ng-template #showToFromAttr>
  <div class="results mt-2" id="showToFromAttr">
    <span i18n = "@@review-partner-content.pagination.showing">Showing <strong>{{displayAttr?.length ? attShowFrom:0 }}
        - {{displayAttr?.length ? attrShowTo : 0}}</strong> of <strong>{{ AttrPageCount }} Attract Loops</strong></span>
  </div>
</ng-template>
<ng-template #topShowtoFromPartner>
  <div class="results" id="topShowtoFromPartner">
    <span i18n="@@review-partner-content.results.showing-of-partner-content-groups">Showing <strong>{{ showFrom }} - {{ showTo }} </strong> of <strong> {{ paginationCount }} Partner Content Groups</strong></span>
  </div>
</ng-template>
<ng-template #noDataForPartner>
  <div class="text-center" *ngIf='noData' id="noDataForPartner">
    <span i18n="@@review-partner-content.no-partners.there-is-no-partner-content-pending-for-review">There is no
      Partner Content pending for review.</span>
  </div>
</ng-template>
<ng-template #noDataForAttr>
  <div class="text-center" *ngIf='!AttrPageCount' id="noDataFOrAttr">
    <span i18n = "@@review-partner-content.noData.no-attract-loop">There is no Attract Loop pending for review.</span>
  </div>
</ng-template>
<!-- IIT2-1435-end -->